<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>🏷️ Configuración de Banner</h2>
      <p class="description">Configura el banner informativo del sistema</p>
    </div>

    <div class="control-section">
      <label for="banner-status">Estado del Banner:</label>
      <select id="banner-status" v-model="bannerStatus" class="admin-select">
        <option :value="0">Desactivado</option>
        <option :value="1">Activado</option>
      </select>
      <p class="help-text">Activar o desactivar la visualización del banner</p>
    </div>

    <div class="control-section">
      <label for="banner-message">Mensaje del Banner:</label>
      <textarea
        id="banner-message"
        v-model="bannerMessage"
        rows="4"
        class="admin-textarea"
        placeholder="Ingrese el mensaje del banner..."
      ></textarea>
      <p class="help-text">Mensaje que se mostrará en el banner</p>
    </div>

    <div class="control-section">
      <label for="banner-color">Color del Banner:</label>
      <div class="color-input-wrapper">
        <input
          type="text"
          id="banner-color"
          v-model="bannerColor"
          class="admin-input color-input"
          placeholder="#RRGGBB"
          maxlength="7"
        />
        <div
          class="color-preview"
          :style="{ backgroundColor: bannerColor }"
        ></div>
      </div>
      <p class="help-text">Color de fondo del banner en formato hexadecimal (#RRGGBB)</p>
    </div>

    <div class="action-section">
      <button @click="saveSettings" class="btn-primary" :disabled="saving">
        {{ saving ? 'Guardando...' : 'Guardar Configuración' }}
      </button>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BannerSettingsTab',
  data() {
    return {
      bannerStatus: 0,
      bannerMessage: '',
      bannerColor: '#3498db',
      saving: false,
      message: '',
      messageType: ''
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/get-banner-settings`);
        if (response.data.success && response.data.settings) {
          this.bannerStatus = parseInt(response.data.settings.status);
          this.bannerMessage = response.data.settings.message || '';
          this.bannerColor = response.data.settings.color || '#3498db';
        }
      } catch (error) {
        console.error('Error loading banner settings:', error);
      }
    },
    async saveSettings() {
      // Validate color format
      const colorRegex = /^#[0-9A-Fa-f]{6}$/;
      if (!colorRegex.test(this.bannerColor)) {
        this.message = 'Formato de color inválido. Use formato hexadecimal (#RRGGBB)';
        this.messageType = 'error';
        return;
      }

      this.saving = true;
      this.message = '';

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/adminmenu/banner-settings`,
          {
            status: this.bannerStatus,
            message: this.bannerMessage,
            color: this.bannerColor
          }
        );

        if (response.data.success) {
          this.message = 'Configuración guardada correctamente';
          this.messageType = 'success';

          setTimeout(() => {
            this.message = '';
          }, 3000);
        } else {
          this.message = response.data.message || 'Error al guardar la configuración';
          this.messageType = 'error';
        }
      } catch (error) {
        this.message = 'Error al guardar la configuración';
        this.messageType = 'error';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.control-section {
  margin-bottom: 20px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  width: 100%;
  max-width: 300px;
}

.admin-textarea {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  padding: 10px;
  width: 100%;
  max-width: 600px;
  resize: vertical;
  font-family: inherit;
}

.admin-input {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
}

.color-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 300px;
}

.color-input {
  flex: 1;
}

.color-preview {
  width: 50px;
  height: 38px;
  border-radius: 4px;
  border: 1px solid #444;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  margin-top: 5px;
}

.action-section {
  margin-top: 20px;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>
